module.exports = ".selected {\r\n    background-color: black;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/pagination/pagination.component.css
// module id = ./src/app/shared/pagination/pagination.component.css
// module chunks = main